<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="1500"
      @click:outside="cancel"
      scrollable
    >
      <v-card>
        <v-card-title class="primary white--text">
          NHẬP EXCEL <v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon @click="cancel">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-5 border">
          <div class="wrap">
            <div
              class="d-flex flex-column justify-center align-center mx-auto"
              style="width: 330px; min-height: 320px"
              v-if="step === 'import'"
            >
              <v-img max-width="100px" max-height="100px" contain src="@/assets/upload-file.svg"></v-img>
              <div class="text-center content-text mt-5" @click="exportExcelTemplate">
                Tải tệp Excel (.xlsx) chứa danh sách giáo viên
              </div>
              <div class="mt-5">
                <v-btn color="primary" class="mr-5" @click="exportExcelTemplate" outlined>Tải mẫu nhập</v-btn>
                <v-btn color="primary" class="elevation-0 white--text" :loading="isSelecting" @click="onExcelUpload">
                  <span class="white--text">Chọn tệp</span>
                  <input
                    ref="uploader"
                    type="file"
                    class="d-none"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="onFileChanged"
                  />
                </v-btn>
              </div>
            </div>
            <div v-else-if="step === 'preview'">
              <PreviewBusTable :data="data" @cancelChooseFile="cancelChooseFile" :file="selectedFile.name" />
            </div>
          </div>
        </v-card-text>
        <hr color="#E0E0E0" />
        <v-card-actions>
          <v-btn class="ma-2" width="100px" outlined light depressed @click="cancel">Hủy</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="step === 'preview' && error == false"
            class="ma-2 primary"
            width="100px"
            dark
            depressed
            @click="save"
            >Lưu</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PreviewBusTable from './DialogImportExcel/PreviewBusTable.vue'
import { headersExcel, dataExcel } from './helper'
import readXlsxFile from 'read-excel-file'
import utils from '@/plugins/utils'
import { BusInformation } from '@/plugins/api.js'
import { mapActions } from 'vuex'

const schema = {
  'Tên xe tuyến': {
    prop: 'stt',
    type: String
  },
  'Tên lái xe': {
    prop: 'driver',
    type: String
  },
  'Đăng kí xe': {
    prop: 'carRegistration',
    type: String
  },
  'Giấy phép lái xe': {
    prop: 'driverLicense',
    type: String
  },
  CCCD: {
    prop: 'cccd',
    type: String
  },
  'GCN tập huấn nghiệp vụ lái xe KDVT': {
    prop: 'certificateTransportDriver',
    type: String
  },
  'Đăng kiểm': {
    prop: 'inspection',
    type: String
  },
  'CN bảo hiểm bắt buộc': {
    prop: 'insuranceCertificate',
    type: String
  },
  'GCN hộ kinh doanh cá thể': {
    prop: 'certificateHousehold',
    type: String
  },
  'Giấy phép KDVT bằng ô tô': {
    prop: 'motorLicense',
    type: String
  },
  'Sơ yếu lý lịch': {
    prop: 'resume',
    type: String
  },
  'Giấy khám sức khỏe': {
    prop: 'healthCertificate',
    type: String
  },
  'Biển số xe': {
    prop: 'licensePlate',
    type: String
  },
  'Ghi chú': {
    prop: 'note',
    type: String
  }
}

export default {
  components: { PreviewBusTable },
  data() {
    return {
      dialog: false,
      step: 'import',
      data: [],
      error: false,
      isSelecting: false
    }
  },
  methods: {
    ...mapActions({
      fetch: 'busInformation/fetch',
      count: 'busInformation/count'
    }),
    openDialog() {
      this.dialog = true
    },
    cancel() {
      this.dialog = false
      this.reset()
    },
    reset() {
      this.step = 'import'
      this.selectedFile = null
      this.error = false
      this.data = []
    },
    async save() {
      try {
        this.$loading.active = true
        const data = this.data.map(item => {
          const clone = { ...item }
          if (clone.healthCertificate === 'Đủ') clone.healthCertificate = true
          else clone.healthCertificate = false
          if (clone.resume === 'Đủ') clone.resume = true
          else clone.resume = false
          if (clone.driverLicense === 'Đủ') clone.driverLicense = true
          else clone.driverLicense = false
          return clone
        })
        await BusInformation.createMany(data)
        this.$alert.success('Tải excel thành công')
        this.fetch({})
        this.count({})
        this.cancel()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    exportExcelTemplate() {
      this.$loading.active = true
      utils.exportExcel(dataExcel, headersExcel, 'Danh sách lái xe')
      this.$loading.active = false
    },
    cancelChooseFile() {
      this.step = 'import'
      this.selectedFile = null
      this.data = []
      this.error = false
    },
    onExcelUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema
        })
      } catch (error) {
        this.$alert.error({
          title: 'File không có định dạng.',
          description: 'xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)'
        })
        this.$loading.active = false
        return
      }
      if (readFileResult.errors && readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const results = readFileResult.rows
        this.data = this.validateData(results)
        this.step = 'preview'
      }
      this.$loading.active = false
    },
    validateData(data = []) {
      console.log('🚀 ~ validateData ~ data:', data)
      const results = []
      this.error = false

      const keysToCheck = [
        'stt',
        'driver',
        'carRegistration',
        'driverLicense',
        'cccd',
        'certificateTransportDriver',
        'inspection',
        'insuranceCertificate',
        'certificateHousehold',
        'motorLicense',
        'resume',
        'healthCertificate',
        'licensePlate',
        'note'
      ]

      data.forEach(item => {
        keysToCheck.forEach(key => {
          item[key] = item[key] === undefined || item[key] === '' ? null : item[key]

          if (this.error === true) return
          if (!item[key] === null) this.error = true
        })

        results.push(item)
      })

      return results
    }
  }
}
</script>
<style>
.wrap {
  border: 1px solid rgb(222, 222, 222);
  border-radius: 4px;
}
</style>
